import { DispatchTripRead } from 'src/common/external/bambi-api/bambiApi';

/**
 * From a set of potential multiload trip IDs (already filtered by time window,
 * payer compatibility, etc.), returns the subset that are already part of a
 * multi-load (i.e. have a non-null multiload_id).
 */
export function getExistingMultiloadTripIdsForAssignment(
  potentialMultiloadTripIds: string[],
  assignedTrips: DispatchTripRead[] | undefined
): string[] {
  if (!assignedTrips || potentialMultiloadTripIds.length === 0) return [];
  const potentialSet = new Set(potentialMultiloadTripIds);
  return assignedTrips
    .filter(
      (t) =>
        potentialSet.has(t.id) && typeof t.multiload_id === 'string'
    )
    .map((t) => t.id);
}
